"use client";

import Image from '@/components/ui/image';
import { useState, useMemo } from "react";
import { cn } from "@/lib/utils";
import { LayoutGrid } from "lucide-react";

// Only names with a file in public/icons: anything else ("General") was a 404
// that the browser logs as a console error on every page showing it.
const ICON_FILES = new Set([
  "Books",
  "Business",
  "Developer Tools",
  "Education",
  "Entertainment",
  "Finance",
  "Food & Drink",
  "Graphics & Design",
  "Health & Fitness",
  "Kids",
  "Lifestyle",
  "Magazines & Newspapers",
  "Medical",
  "Music",
  "Navigation",
  "News",
  "Photo & Video",
  "Productivity",
  "Reference",
  "Shopping",
  "Social Networking",
  "Sports",
  "Travel",
  "Utilities",
  "Weather",
]);

export function CategoryIcon({ name, className }: { name?: string; className?: string }) {
  const [errored, setErrored] = useState(false);
  const src = useMemo(() => {
    if (!name || !ICON_FILES.has(name)) return undefined;
    const encoded = encodeURIComponent(name);
    return `/icons/${encoded}.png`;
  }, [name]);

  if (!src || errored) {
    return <LayoutGrid className={cn("h-4 w-4 text-muted-foreground", className)} />;
  }

  return (
    <Image
      src={src}
      alt=""
      width={16}
      height={16}
      className={cn("h-4 w-4 align-text-bottom", className)}
      onError={() => setErrored(true)}
      unoptimized
    />
  );
}
